<app-alert></app-alert>

@switch (layout) {
  @case (LayoutsEnum.Auth) {
    <app-auth-layout />
  }
  @case (LayoutsEnum.Default) {
    <app-default-layout />
  }
  @case (LayoutsEnum.AdminDefault) {
    <app-admin-default-layout />
  }
  @case (LayoutsEnum.Admin) {
    <app-admin-layout />
  }
  @case (LayoutsEnum.Preview) {
    <app-preview-layout />
  }
}
